import { render, staticRenderFns } from "./PrivacyPolicyES.vue?vue&type=template&id=7967d07a&scoped=true"
import script from "./PrivacyPolicyES.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyES.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyES.vue?vue&type=style&index=0&id=7967d07a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7967d07a",
  null
  
)

export default component.exports